import {
  zodContractPayloadBaseSchema,
  zodContractResponseSchema,
} from '../validations';

// Request payload schema for updating a contract (all fields optional)
export const zodUpdateContractPayloadSchema = zodContractPayloadBaseSchema;

// Response schema (re-export from shared)
export { zodContractResponseSchema as zodUpdateContractResponseSchema };
